export default {"src":"/_next/static/media/lightSnow.b6056bef.svg","height":156,"width":156};